import React, {useEffect, useState} from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import axios from "axios";
import {useUser} from "../../common/ProtectedRoute";
import {ErrorMessage} from "../../common/ErrorMessage";
import {LoadingButton} from "@mui/lab";
import {UploadStageFile} from "../../../api/application/getMyApplicationDetails";
import {Button} from "@mui/material";
import {useLazyQuery} from "@apollo/client";
import {GET_PRESIGNED_URL} from "../../../api/stage/getPresignedUrl";

type UploadFileProps = {
    disabled: boolean,
    fileData: UploadStageFile,
    onUpload: (fileId: string | undefined) => void,
}

export const UploadFile = (props: UploadFileProps) => {
    const {disabled, fileData, onUpload} = props

    const user = useUser()

    const [file, setFile] = useState<File>()
    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const [getTheFileUrl] = useLazyQuery(GET_PRESIGNED_URL);

    const handleDownload = async (fileId: string) => {
        const {error, data} = await getTheFileUrl({variables: {fileId}})

        if (!error && data !== undefined) {
            const link = document.createElement('a');
            link.download = 'Example-PDF-File';
            link.href = data.getPresignedUrl;
            link.click();
        }
    };

    useEffect(() => {
        if (file === undefined) return

        setIsLoading(true)

        const formData = new FormData();
        formData.append("file", file);

        axios.post(`${process.env.REACT_APP_RESTFUL}files/upload`, formData, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Authorization": user.token,
                "Content-Type": "multipart/form-data",
            },
        }).then((response) => {
            onUpload(response.data.file.id);
            setIsLoading(false)
        }).catch((error) => {
            setErrorMessage(error.message)
            setFile(undefined)
            setIsLoading(false)
        });
    } , [file])

    const {fileId} = fileData

    return (
        <Stack direction="row" paddingY={1} flexWrap="wrap" gap="1rem" alignItems="center">
            {fileId ? (
                <Button disabled={disabled} onClick={() => handleDownload(fileId)}>
                    Download File
                </Button>
            ) : undefined}

            <Typography>
                {fileData.title}
            </Typography>

            {!fileId ? (
                <>
                    <LoadingButton
                        component="label"
                        disabled={disabled}
                        size="small"
                        variant="outlined"
                        loading={isLoading}
                    >
                        {file === undefined ? 'Upload File' : file.name}
                        <input
                            type="file"
                            hidden
                            accept={fileData.requiredFileType === 'pdf' ? '.pdf' : '.jpg, .jpeg, .png'}
                            onChange={(e) => setFile(e.target.files ? e.target.files[0] : undefined)}
                        />
                    </LoadingButton>
                    <Typography>
                        {
                            fileData.requiredFileType === 'pdf'
                                ? 'File Must be a PDF document'
                                : 'File Must be an image'
                        }
                    </Typography>
                </>
            ) : undefined}

            <ErrorMessage
                handleClose={() => setErrorMessage('')}
                isOpen={errorMessage !== ''}
                message={errorMessage}
            />
        </Stack>
    )
}
